/** venture/CoStatBar.tsx — 법인별 대기/진행/완료 컨트롤 (8단계~, 진행상태 이원화 2026-07-19)
 *  단계 커서는 법인마다 독립. 완료 처리 시 미완료 항목이 있으면 토스트로 알리되 막지는 않는다
 *  (타임라인 [완료] 버튼의 기존 동작과 동일한 정책). */
import React from 'react';
import { coStat, setCoStat } from './costep';
import type { Stat } from './costep';
import { coReadiness } from './readiness';
import type { Project, CoCard } from './types';

const OPTS: [Stat, string][] = [['wait', '대기'], ['cur', '진행'], ['done', '완료']];

interface Props {
  p: Project;
  co: CoCard;
  n: number;
  onPatch: (patch: Partial<Project>) => void;
  toast: (m: string) => void;
  folded?: boolean;
  onFold?: () => void;
}

export default function CoStatBar({ p, co, n, onPatch, toast, folded, onFold }: Props) {
  const st = coStat(p, co.id, n);
  const rd = coReadiness(p, co, n);
  const ready = rd.total > 0 && rd.missing.length === 0;

  const pick = (s: Stat) => {
    if (s === st) return;
    if (s === 'done' && rd.missing.length) {
      toast((co.name || '법인') + ' — 미완료 ' + rd.missing.length + '건 상태로 완료 처리했습니다');
    }
    onPatch(setCoStat(p, co.id, n, s));
  };

  return (
    <div className={'costat ' + st} onClick={(e) => e.stopPropagation()}>
      <span className={'pill ' + (ready ? 'p-green' : 'p-gray')}>{rd.done}/{rd.total}</span>
      <span className="grow" />
      {OPTS.map((o) => (
        <button key={o[0]} className={'cbtn ' + o[0] + (st === o[0] ? ' on' : '')} onClick={() => pick(o[0])}>{o[1]}</button>
      ))}
      {onFold ? (
        <button className="cbtn fold" title={folded ? '펼치기' : '접기'} onClick={onFold}>{folded ? '▾' : '▴'}</button>
      ) : null}
    </div>
  );
}
